export const onlyNumbers = {
  mounted: (el: any) => {
    el.getElementsByTagName('input')[0].addEventListener('keydown', (event: any) => {
      if (event.key.match(/\d/) || event.keyCode == 46 || event.keyCode == 8) {
        return
      }

      if (event.key === '.' && (event.target as HTMLInputElement).value.indexOf('.') === -1) {
        return
      }

      event.preventDefault()
    })
  },
}

export const onlyNumbersNoDigits = {
  mounted: (el: any) => {
    el.getElementsByTagName('input')[0].addEventListener('keydown', (event: any) => {
      if (event.key.match(/\d/) || event.keyCode == 46 || event.keyCode == 8) {
        return
      }

      event.preventDefault()
    })
  },
}
